import { memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { PublicOutlined } from '@material-ui/icons'
import { FormControl, MenuItem, Select } from '@material-ui/core'

import { getVideoBridgeRegions } from '@tabeeb/modules/appConfigState/selectors'

import * as presentationSelectors from '@tabeeb/modules/presentation/selectors'
import * as contentStateSelectors from '@tabeeb/modules/shared/content/selectors'
import { getIsVideobridgeSelectorVisible } from '@tabeeb/modules/whiteboard/selectors'
import { setSelectedVideoBridge, setVideoBridgeRequest } from '@tabeeb/modules/whiteboard/actions'

import SettingsField from '../SettingsField'

const VideoBridgeRegions = () => {
  const dispatch = useDispatch()

  const contentId = useSelector(contentStateSelectors.getContentId)
  const isCallStarted = useSelector(presentationSelectors.getIsCallStarted)
  const isVisible = useSelector(getIsVideobridgeSelectorVisible)

  const regions = useSelector(getVideoBridgeRegions)
  const currentVideoBridge = useSelector((state) => state.whiteboard.currentVideoBridge)

  const onChangeVideoBridgeRegion = (event) => {
    const selectedRegion = event.target.value
    if (selectedRegion.url === currentVideoBridge.url) {
      return
    }

    dispatch(setSelectedVideoBridge(selectedRegion))
    dispatch(
      setVideoBridgeRequest({
        ContentId: contentId,
        VideobridgeUrl: selectedRegion.url,
      })
    )
  }

  if (!isVisible) {
    return null
  }

  return (
    <SettingsField icon={PublicOutlined} label='Video chat region'>
      <FormControl size='small'>
        <Select
          disabled={isCallStarted}
          value={currentVideoBridge}
          onChange={onChangeVideoBridgeRegion}
          title={currentVideoBridge.name}
          disableUnderline
        >
          {regions.map((region, index) => {
            return (
              <MenuItem key={index} value={region}>
                {region.name}
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    </SettingsField>
  )
}

export default memo(VideoBridgeRegions)
